
import { Colors } from '../../consts/Colors';

export default class Card3 extends Phaser.GameObjects.Container {
    constructor(scene, x, y, cardData, deck) {
        super(scene, x, y, []);

        scene.add.existing(this);
        this.initPosition = { x: x, y: y }
        this.scene = scene;
        this.isDone = false;


        this.img = cardData.image + "Noir"
        this.trueId = cardData.trueId;
        this.trueId2 = cardData.trueId2;
        this.zoneId = cardData.zoneId;
        this.correct = cardData.correct
        this.correct1 = cardData.correct1
        this.correct2 = cardData.correct2
        this.corrections = cardData.corrections

        this.deck = deck

        this.cardImage = this.scene.add.image(0, -30, this.img).setOrigin(0.5);
        this.add(this.cardImage);
        this.rect = this.scene.add.rectangle(0, -30, this.cardImage.width, this.cardImage.height, Colors.Elmt.Blue, 0).setOrigin(0.5);

        this.add(this.rect);

        this.setSize(this.cardImage.width, this.cardImage.height);
        this.setInteractive({ useHandCursor: true });
        this.scene.input.setDraggable(this)

    }
    drop(pointer, gameObject, dropZone) {
        if (dropZone.zoneId == gameObject.zoneId) {
            this.rect.setStrokeStyle(8, Colors.Elmt.Green, 1);


            if (dropZone.trueId == gameObject.trueId) {
                dropZone.setDone(this.img)

            } else if (dropZone.trueId != gameObject.trueId) {
                dropZone.item.setTint(0xFFFFFF);
                this.scene.zones.find(x => x.trueId == gameObject.trueId).setDone(this.img)
            }
            this.deck.setDeckTrue(gameObject.correct)
            this.scene.game.data.cardNumber2++
        } else {
            this.rect.setStrokeStyle(8, Colors.Elmt.Red, 1);
            dropZone.setWrong(this.img)
            this.corrections.forEach(x => {
                let y = x.ids.includes(dropZone.zoneId)

                if (y) {
                    this.deck.setDeckFalse(x.texte, x.presque)

                }
            })
        }

        this.scene.allZonesDone.forEach(newZone => {
            newZone.setInteractive();
            newZone.on('pointerout', () => {
                newZone.setScale(0.5)
                // newZone.setDepth(0)
            })
            newZone.on('pointerover', () => {
                newZone.setScale(1)
                // newZone.setDepth(1)
            })

        })
        gameObject.destroy()
    }

    dragEnd(pointer, gameObject, dropped) {
        if (!dropped) {
            gameObject.resetPosition()
            this.scene.allZonesDone.forEach(newZone => {
                newZone.setInteractive();
                newZone.on('pointerout', () => {
                    newZone.setScale(0.5)
                    // newZone.setDepth(0)
                })
                newZone.on('pointerover', () => {
                    newZone.setScale(1)
                    // newZone.setDepth(1)
                })

            })
        }
    }

    setDone() {
        this.isDone = true
    }
    onDrag() {
        this.scene.allZonesDone.forEach(newZone => {
            newZone.setDepth(0)
            newZone.disableInteractive()
        })
    }
    resetPosition(duration) {
        if (duration == undefined) {
            duration = 300
        }


        this.scene.tweens.add({
            targets: this,
            duration: duration,
            x: this.initPosition.x,
            y: this.initPosition.y,
            scale: 1,
            onComplete: () => {
                this.setInteractive({ useHandCursor: true })
            }
        })
    }
    dragStartAnnim() {
        this.scene.tweens.add({
            targets: this,
            duration: 200,
            scale: 0.7,
            onComplete: () => {
            }
        })
    }

}